import React from "react";
import { FiInfo } from "react-icons/fi";

export default function SystemInformation() {
  const systemData = [
    { label: "Router Kart version", value: "4.90.1" },
    { label: "Operating system", value: "Microsoft Windows NT 10.0.17763.0" },
    { label: "ASP.NET info", value: ".NET 9.0.10" },
    { label: "Is full trust level", value: "Yes" },
    { label: "Server time zone", value: "Pacific Standard Time" },
    { label: "Server local time", value: "Wednesday, November 5, 2025 8:49:14 PM" },
    { label: "Coordinated Universal Time (UTC)", value: "Thursday, November 6, 2025 4:49:14 AM" },
    { label: "Current user time", value: "Wednesday, November 5, 2025 8:49:14 PM" },
    { label: "HTTP_HOST", value: "admin-demo.routekart.com" },
  ];

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <h1 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
          <FiInfo className="text-blue-600" /> System Information
        </h1>
        <button className="mt-3 sm:mt-0 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium">
          Refresh
        </button>
      </div>

      {/* Info Card */}
      <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm sm:text-base">
            <tbody>
              {systemData.map((item, index) => (
                <tr
                  key={index}
                  className={`border-b last:border-none hover:bg-gray-50 transition-colors`}
                >
                  <td className="font-medium text-gray-700 py-3 px-3 w-1/3 sm:w-1/4 whitespace-nowrap">
                    {item.label}
                  </td>
                  <td className="text-gray-600 py-3 px-3 break-all">
                    {item.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
      <div className="text-sm text-gray-500 mt-6 text-center">
        <p>Last updated on November 6, 2025</p>
      </div>
    </div>
  );
}
